<template lang='pug'>
.record-container
    userCard
    .tab-container
        van-tabs(v-model="active")
            van-tab(title="积分变更记录")
                .content 
                    .line
                .content-box
                    .item(v-for="item in recordData" :key="item.id")
                        .item-left
                            .record {{ item.remark }}
                            .time {{ item.time }}
                        .item-right
                            .point {{ item.point }}
            van-tab(title="积分兑换记录")
                .content 
                    .line
                .content-box
                    .item(v-for="item in exchangeData" :key="item.id")
                        .item-left
                            .record {{ item.remark }}
                            .time {{ item.time }}
                        .item-right
                            .point {{ item.point }}
</template>

<script>
import userCard from './components/userCard'
import { getPointRecords } from '@/service/member'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
export default {
    name: 'record',
    data() {
        return {
            active: 0,
            recordData: [],
            exchangeData: []
        }
    },
    components: {
        userCard
    },
    async created() {
        this.$root.$emit('action', { name: this.$route.name })
        const [{ data: recordData }, { data: exchangeData }] = await Promise.all([getPointRecords(), getPointRecords({ sourceType: 4 })])
        // console.log(recordData)
        this.recordData = recordData.map(val => {
            return {
                id: val.id,
                remark: val.remark,
                time: dayjs(val.createTime).format("YYYY.MM.DD HH:mm:ss"),
                point: `${val.action === 'Add' ? '+' : '-'}${val.pointChange}.00`
            }
        })
        this.exchangeData = exchangeData.map(val => {
            return {
                id: val.id,
                remark: val.remark,
                time: dayjs(val.createTime).format("YYYY.MM.DD HH:mm:ss"),
                point: `${val.action === 'Add' ? '+' : '-'}${val.pointChange}.00`
            }
        })
        // let from =new Date(new Date().toLocaleDateString())
        //      const isSign=await getPointRecords({index:1,size:1,from:from,to:new Date(),SourceDescriptions:["801363836862345216"]})
        // console.log(dayjs(time).format("YYYY.MM.DD HH:mm:ss") )
    },
    computed: {
        ...mapState(['memberInfo', 'userInfo', 'bookMarks', 'bookMarksLoading'])
    },
    methods: {
    }
}
</script>

<style scoped lang='less'>
/deep/.van-tab--active {
    color: #07448a;
    font-weight: 700;
}
/deep/.van-icon-cross::before {
    color: black;
}

/deep/.van-tabs__wrap {
    padding-left: 3.9rem;
    padding-right: 3.9rem;
    height: 1.5rem;
}
/deep/van-tab__text {
    font-size: 0.65rem;
}
/deep/.van-tabs__line {
    background: #07448a;
}
/deep/.van-tab {
    flex: none;
    padding: 0;
}
/deep/.van-tabs__nav {
    justify-content: space-between;
}
/deep/.van-tabs__line {
    width: 3.95rem;
    height: 0.1rem;
}
.line {
    position: absolute;
    width: 100%;
    height: 0.1rem;
    background: #f3f3f3;
    top: -0.1rem;
}
.content {
    position: relative;
}
.content-box {
    img {
        width: 4.7rem;
        height: 3.9rem;
        object-fit: cover;
    }
}
.record-container {
    .tab-container {
        margin-top: 1rem;
        .content-box {
            padding: 0rem 1rem 3rem 1rem;
            display: flex;
            flex-direction: column;
            .item-right {
                display: flex;
                align-items: center;
                font-size: 0.8rem;
                color: #219cdc;
            }

            .item {
                &:nth-child(1) {
                    margin-top: 1rem;
                }
                display: flex;
                justify-content: space-between;
                // align-items: center;
                width: 100%;
                margin-bottom: 0.6rem;
                background: #f3f3f3;
                border-radius: 0.2rem;
                padding: 0.5rem;
                .record {
                    line-height: 1rem;
                    font-size: 0.7rem;
                    color: #07448a;
                    margin-bottom: 0.2rem;
                }
                .time {
                    color: #646464;
                    height: 0.85rem;
                    line-height: 0.85rem;
                    font-size: 0.6rem;
                }
            }
        }
    }
}
.img-box {
    width: 4.7rem;
    margin: 0 auto;
    margin-top: 4.4rem;
    .img-container {
        width: 100%;
        height: 3.9rem;
        img {
            display: block;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
    .text {
        height: 0.85rem;
        line-height: 0.85rem;
        font-size: 0.6rem;
        color: #646464;
        text-align: center;
        margin-top: 0.6rem;
    }
}
</style>